import { useCallback } from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { FormErrorMessage } from 'components/UI/forms';

type RecaptchaProps = {
  error?: string;
  onChange: (token: string) => void;
};

const Recaptcha = ({ error, onChange }: RecaptchaProps) => {
  const handleVerify = useCallback((token: string) => onChange(token), []);

  return (
    <>
      <GoogleReCaptcha onVerify={handleVerify} />
      <FormErrorMessage>{error}</FormErrorMessage>
    </>
  );
};

export { Recaptcha };
